import { getOrCreateAgentId } from "./lib/getOrCreateAgentId"
import { sample } from "./lib/random"

export const cohort = (id: string) => (checksum(id) % 2 === 0 ? "odd" : "even")

const bgndsByCohort = {
  odd: "/zdenek-machacek-jbe0iCwo-U0-unsplash.jpg",
  even: "/brandi-redd-sk3zYkMbySk-unsplash-compressed.jpg",
}

export const IconAnimationInDeciseconds: number = sample([5, 4, 3, 2, 1]) || 0

export const backgroundURL = bgndsByCohort[cohort(getOrCreateAgentId())]

export const titleFieldPlaceholder =
  sample([
    "e.g. What's on our itinerary?",
    "e.g. Where should we visit, next?",
    "e.g. Whom should we invite to speak?",
    "e.g. Where should we host the gala?",
    "e.g. What theme should we pick for the gala?",
    // "e.g. Where to get lunch?",
    "e.g. Who is the greatest rock band of all time?",
    "e.g. What should we name the dog?",
    "e.g. Which appetizers should we get?",
    "e.g. Where should we stop on our road trip?",
  ]) || ""

export const dragIconLigature =
  sample(["drag_indicator", "drag_handle", "reorder"]) || "drag_indicator"

export const landingPageTitle =
  sample(["Druthers: get yours.", "Quit bickering.", "Bicker quicker."]) ||
  "Druthers"

function checksum(s: string): number {
  var chk = 0x12345678
  var len = s.length
  for (var i = 0; i < len; i++) {
    chk += s.charCodeAt(i) * (i + 1)
  }

  return chk & 0xffffffff
}
